import type { MotorPerformanceChartContext } from "./d";
import { Ratio } from "@/libs/units/percentage";

export const getMotorOperatingPoints = (
  context: MotorPerformanceChartContext
) => {
  const {
    motorLoadRatio,
    motorEfficiencyRatio,
    motorPowerFactor,
    motorCurrentA
  } = context;
  return [
    {
      label: "Efficiency",
      color: "var(--plotColor0)",
      point: {
        x: Ratio.toStandardUnit(motorLoadRatio),
        y: Ratio.toStandardUnit(motorEfficiencyRatio)
      },
      yLabel: "Eff %"
    },
    {
      label: "Power Factor",
      color: "var(--plotColor1)",
      point: {
        x: Ratio.toStandardUnit(motorLoadRatio),
        y: motorPowerFactor
      },
      yLabel: "PF"
    },
    {
      label: "Percent Current",
      color: "var(--plotColor2)",
      point: {
        x: Ratio.toStandardUnit(motorLoadRatio),
        y: Ratio.toStandardUnit(motorCurrentA)
      },
      yLabel: "% Current"
    }
  ];
};
